import React, { memo } from "react";
import { useFormContext } from "react-hook-form";
import { FieldType } from "models/formField";
import {
  FormFieldProps,
  getFieldComponent,
} from "helpers/formField.components.helper";

export const FormField: React.FC<FormFieldProps> = memo(
  ({ config, control: controlProp, errors: errorsProp, watch: watchProp }) => {
    // Try to get form context (will be undefined if not inside FormProvider)
    const formContext = useFormContext();

    // Use props if provided, otherwise fall back to context
    const control = controlProp ?? formContext?.control;
    const errors = errorsProp ?? formContext?.formState?.errors;
    const watch = watchProp ?? formContext?.watch;

    // Validate that we have the required control
    if (!control) {
      console.error(
        `FormField "${config.name}" requires either a control prop or to be wrapped in FormProvider`,
      );
      return null;
    }

    // Get the component for this field type
    const FieldComponent = getFieldComponent(config.type);

    if (!FieldComponent) {
      console.warn(`Field type "${config.type}" is not supported.`);
      return null;
    }

    // Render the field component with the provided props
    return (
      <FieldComponent
        config={config}
        control={control}
        errors={errors}
        watch={watch}
      />
    );
  },
);

FormField.displayName = "FormField";

// Export field type enum for convenience
export { FieldType } from "models/formField";

// Export FormFieldProps for external use
export type { FormFieldProps } from "helpers/formField.components.helper";
